module.exports = __webpack_public_path__ + "images/vkb_fa_male.svg?497af678994d67f53961ede5b6309fcd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vkb_fa_male.svg
// module id = 7gOm
// module chunks = 0